module.exports = __webpack_public_path__ + "img/page8img1.fdcc62d7.png";